import { ToastService } from '@tcc-mono/shared/ui/services';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  private readonly _toast = inject(ToastService);
  private readonly _authService = inject(AuthenticationService);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === HttpStatusCode.Unauthorized) {
            if (this._isAuthTokenRequest(req)) {
              return throwError(() => error);
            }

            // Exact 401 is a downstream token, not the VDV session.
            if (this._isExactDownstreamRequest(req)) {
              if (!req.url.includes('/api/exact')) {
                this._showErrorToast(error);
              }
              return throwError(() => error);
            }

            this._authService.handleUnauthorized();
            return throwError(() => error);
          }

          // Don't show toast for 409 conflicts - let the component handle them
          if (error.status === HttpStatusCode.Conflict) {
            return throwError(() => error);
          }

          this._showErrorToast(error);
          return throwError(() => error);
        })
      );
  }

  private _showErrorToast(error: HttpErrorResponse): void {
    this._toast.show({
      header: error.status.toString(),
      message: error.error?.error || error.error?.message || error.message || error,
      color: 'danger'
    });
  }

  private _isAuthTokenRequest(req: HttpRequest<unknown>): boolean {
    return req.url.includes('/oauth/token');
  }

  private _isExactDownstreamRequest(req: HttpRequest<unknown>): boolean {
    return req.url.includes('/api/exact')
      || req.url.includes('export-to-exact')
      || req.url.includes('/export/exact');
  }
}
